/* Selector file rule: root-level functions in this file must be exported selectors only. Move helper functions to lib files. */
import { createSelector } from 'reselect';
import { isPieveAppVisible } from '@shared/apps/isPieveAppVisible.js';
import getChromePrimaryActionIdFromPath from '@/lib/routes/getChromePrimaryActionIdFromPath.js';
import { EMPTY_ARRAY } from '@/redux/selectors/pieveSelectors/constants.js';
import { authAdmin as selectedUserIsMindcloudAdmin, companyId as selectedUserCompanyId } from '@/redux/selectors/userSelectors.js';
import { pathname as selectedPathname } from '@/redux/selectors/uiSelectors.js';

// The runtime's identity and capabilities live in their own import-free file so `uiSelectors.js` can read them too.
export * from '@/redux/selectors/pieveSelectors/runtimeCapabilitySelectors.js';

const storedAppsMetadataItems = (state) => state?.pieve?.appsMetadataItems || EMPTY_ARRAY;
export const appsMetadataItems = createSelector([storedAppsMetadataItems, selectedUserCompanyId, selectedUserIsMindcloudAdmin], (items, companyId, isMindcloudAdmin) => {
  return items.filter((app) => isPieveAppVisible({ app, companyId, isMindcloudAdmin }));
});
// One visible app by id. Anything minting a credential needs the real catalog record (its auth types
// decide the credential's default), and it must be the visibility-filtered list — an app this company
// cannot see is not one it can connect.
export const appMetadataForId = (state, appId) => {
  const normalizedAppId = String(appId || '').trim();

  return normalizedAppId ? appsMetadataItems(state).find((app) => app?.id === normalizedAppId) || null : null;
};

export const appsMetadataEtag = (state) => String(state?.pieve?.appsMetadataEtag || '').trim() || null;
export const appsMetadataCount = createSelector([appsMetadataItems], (items) => {
  return items.length;
});
export const appsMetadataLoaded = (state) => state?.pieve?.appsMetadataLoaded === true;

export const activePrimaryActionId = createSelector([selectedPathname], (pathnameValue) => {
  return getChromePrimaryActionIdFromPath(pathnameValue);
});
